import { FilterColor, ImageWithInfo } from '../../empracoTypes';
import { FileExtensions } from '../../util/util';
import { CSSProperties } from 'react';

function renderImg(url: string, alt: string, css: CSSProperties) {
  const width = 200;
  const height = css.maxHeight ? css.maxHeight : 75;

  return <img
    width={width}
    height={height}
    src={url}
    alt={alt}
    loading='lazy'
    style={css} />;
};

interface LogotypeImageProps extends ImageWithInfo {
  externalLink: boolean;
  maxHeight?: number;
  filterColor: FilterColor;
  parentStyling?: CSSProperties;
}

export function Logotype(props: LogotypeImageProps) {
  if (!props.imgUrl) {
    return null;
  }

  const url = props.imgUrl.includes(FileExtensions.SVG)
    ? props.imgUrl
    : `${props.imgUrl}?width=200&format=webp`;

  const setTarget = () => {
    if (props.externalLink && (props.pageLink.startsWith('http') || props.pageLink.startsWith('www'))) {
      return '_blank';
    }

    return '_self';
  };

  const setInlineStyling = () => {
    const css = {filter: 'none', maxHeight: 'unset'};

    if (props.maxHeight) {
      css.maxHeight = `${props.maxHeight}px`;
    }

    if (!url || !url.includes(FileExtensions.SVG)) {
      return css;
    }

    if (props.filterColor === FilterColor.black) {
      css.filter = 'brightness(0)';
    }

    if (props.filterColor === FilterColor.gray) {
      css.filter = 'grayscale(1)';
    }

    if (props.filterColor === FilterColor.white) {
      css.filter = 'brightness(0) invert(1)';
    }

    return css;
  };

  if (props.pageLink) {
    return(
      <div className='empori-logotype' style={props.parentStyling ? props.parentStyling : {}}>
        <a href={props.pageLink} title={props.imgAlt} target={setTarget()}>
          {renderImg(url, props.imgAlt, setInlineStyling())}
        </a>
      </div>
    );
  }

  return(
    <div className='empori-logotype' style={props.parentStyling ? props.parentStyling : {}}>
      {renderImg(url, props.imgAlt, setInlineStyling())}
    </div>
  );
}